export const pageElementDisplayMapping = {
  TEXT: 'Text',
  GALLERY: 'Gallery',
  TRIPLE_IMAGE: 'Triple Image',
} as const
